import React from "react";
import ShopType from "@/enum/ShopType";

interface LoginFormItem {
    type: string;
    password: boolean;
    label: string;
    name: string;
    required: boolean;
}

interface PlatformLoginFormInfoData {
    items: LoginFormItem[];
    help?: React.ReactNode;
}

const LoginFormMapping: Record<string, PlatformLoginFormInfoData> = {
    [ShopType.WEBUY]: {
        items: [
            {
                type: "input",
                password: false,
                label: "鲸灵、好衣库店铺Id",
                name: "supplierDockId",
                required: true,
            },
        ],
        help: (
            <span>
                如何查看鲸灵、好衣库店铺id？
                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcntUyUrC7iSXysIvbSci4a9e" target="_blank">
                    请点击这里查看教程
                </a>
            </span>
        ),
    },
    [ShopType.HAIZIWANG]: {
        items: [
            {
                type: "input",
                password: false,
                label: "登录名",
                name: "loginName",
                required: true,
            },
            {
                type: "input",
                password: false,
                label: "appKey",
                name: "appKey",
                required: true,
            },
        ],
        help: (
            <span>
                如何查看孩子王的登录名和AppKey？
                <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnXYd3RZJeN95TPmPIm9Ew0b" target="_blank">
                    请点击这里查看教程
                </a>
            </span>
        ),
    },
    [ShopType.AIKUCUN]: {
        items: [
            {
                type: "input",
                password: false,
                label: "APPID",
                name: "appKey",
                required: true,
            },
            {
                type: "input",
                password: true,
                label: "密钥",
                name: "appSecret",
                required: true,
            },
        ],
        help: (
            <span>
                如何获取爱库存APPID和密钥？
                <a
                    href="https://qw15p3s8hv.feishu.cn/wiki/wikcn6mmJWHTXG25jPrkqx1ibKf"
                    target="https://qw15p3s8hv.feishu.cn/wiki/wikcn6mmJWHTXG25jPrkqx1ibKf"
                >
                    点击这里查看教程
                </a>
            </span>
        ),
    },
    [ShopType.AIKUCUN_V2]: {
        items: [
            {
                type: "input",
                password: false,
                label: "APPID",
                name: "appKey",
                required: true,
            },
            {
                type: "input",
                password: true,
                label: "密钥",
                name: "appSecret",
                required: true,
            },
        ],
        help: (
            <span>
                如何获取爱库存APPID和密钥？
                <a
                    href="https://qw15p3s8hv.feishu.cn/wiki/wikcn6mmJWHTXG25jPrkqx1ibKf"
                    target="https://qw15p3s8hv.feishu.cn/wiki/wikcn6mmJWHTXG25jPrkqx1ibKf"
                >
                    点击这里查看教程
                </a>
            </span>
        ),
    },
    [ShopType.SDMM]: {
        items: [
            {
                type: "input",
                password: false,
                label: "接口账号(API Key)",
                name: "apiKey",
                required: true,
            },
            {
                type: "input",
                password: true,
                label: "接口密码(API Secret)",
                name: "apiSecret",
                required: true,
            },
        ],
        help: <span>API Key 和 API Secret 请联系神灯妈妈相关人员获取</span>,
    },
    [ShopType.YMDY]: {
        items: [
            {
                type: "input",
                password: false,
                label: "接口账号(API Key)",
                name: "apiKey",
                required: true,
            },
            {
                type: "input",
                password: true,
                label: "接口密码(API Secret)",
                name: "apiSecret",
                required: true,
            },
        ],
    },
    [ShopType.HCTY]: {
        items: [
            {
                type: "input",
                password: false,
                label: "接口账号(API Key)",
                name: "apiKey",
                required: true,
            },
            {
                type: "input",
                password: true,
                label: "接口密码(API Secret)",
                name: "apiSecret",
                required: true,
            },
        ],
    },
    [ShopType.DOUBB]: {
        items: [
            {
                type: "input",
                password: false,
                label: "接口账号(API Key)",
                name: "apiKey",
                required: true,
            },
            {
                type: "input",
                password: true,
                label: "接口密码(API Secret)",
                name: "apiSecret",
                required: true,
            },
        ],
        help: (
            <span>
                如何获取播城接口账号和接口密码?
                <a href="https://qw15p3s8hv.feishu.cn/wiki/BSsmwbUkNiIjm4kKmGgc2TcCnag" target="_blank">
                    点击这里查看教程
                </a>
            </span>
        ),
    },
};

export default LoginFormMapping;
